module.exports = __webpack_public_path__ + "static/media/store_x2.c1ebf573.svg";